const ErrorMessages = {
  loginError: "These credentials do not match with our records.",
  name: "Name is required",
  admissionNumber: "Admission number is required",
  admissionNumberTaken: "Admission number is taken",
  dateOfBirth: "Select your D.O.B.",
  fatherName: "Father name is required",
  maritalStatus: "Choose your marital status",
  address: "Enter your full address",
  contactNumber: "Contact number is required",
  reference: "Enter your reference",
  fatherhusband: "Enter father/husband contact number",
  email: "Enter your email",
  emailPattern: "Enter valid email e.g. john@mail.com",
  admissionDate: "Choose admission date",
  demoDate: "Choose demo date",
  courses: "Choose a particular course",
  batches: "Choosing a batch is required",
  paymentDuration: "Choose duration for payment",
  monthlyPayment: "Payment is required",
  paymentNumeric: "Payment must be numeric value",
  description: "Description is required",
  phone: "Please enter your phone number.",
  phoneNumber: "Phone number must be in numeric format.",
  demoCategory: "Choose category for demo",
  visaType: "Choose visa type",
  refusalReason: "Enter refusal reason",
  panNumber: "PAN Number is required",
  joiningDate: "Select your joining date",
  salary: "Enter your monthly salary",
  salaryNumber: "Salary must be in numeric format",
  fatherHusbandName: "Enter your father/husband name",
  assginbatches: "Batch Info is required",
  batchName: "Batch name ie required",
  batchSelection: "Select batch",
  typeOfExpense: "Choose expense type",
  teacherID: "Enter teacher ID",
  daysSelected: "Enter days in which teacher is present",
  date: "Enter date e.g. yyyy/mm",
  salaryMonth: "Choose the date e.g. mm/yyyy",
  password: "Enter your password",
  confirmPassword: "Re-enter your passowrd",
  passwordLength: "Password must be alteast 6 characters long",
  role: "Select your role",
  batchStartTime: "Choose batch starting time",
  batchEndTime: "Choose batch ending time",
  teacherId: "Teacher ID is required",
  noOfDays: "Enter no. of present days",
  noOfDaysFormat: "Enter the value in numeric format",
  amount: "Enter amount",
  amountNumber: "Amount must be in numeric format",
  pteId: "PTE ID is required",
  studentSelect: "Please select students",
  studentInfo: "Select student category",
  studentName: "Student Name is required",
  testDate: "Select test date",
  speakingMarks: "Speaking marks are required",
  writingMarks: "Writing marks are required",
  listeningMarks: "Listening marks are required",
  readingMarks: "Reading marks are required",
  city: "City is required",
  pinCode: "PIN code is required",
  pteStudentName: "Enter PTE student name",
  overallMarks: "Overall marks is required",
  studentType: "Choose type of students",
  businessName: "Business name is required",
  country:"Enter your dream country",
  visaFee: "Enter visa fee",
  processtiming: "Enter process timing",
  department: "Enter your department",
  designation: "Enter designation",
  paymentMethod: "Please choose payment method",
  monthDate: "Choose the month e.g. mm/yyyy",
  feeDate: "Choose date e.g. yyyy/mm/dd",
  notesData: "Enter description"
};

export default ErrorMessages;
